var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPayMent2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IconPayMent"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00065 2.66797C2.52789 2.66797 1.33398 3.86188 1.33398 5.33464V10.668C1.33398 12.1407 2.52789 13.3346 4.00065 13.3346H6.66732C7.03551 13.3346 7.33398 13.0362 7.33398 12.668C7.33398 12.2998 7.03551 12.0013 6.66732 12.0013H4.00065C3.26427 12.0013 2.66732 11.4043 2.66732 10.668V7.33463H13.334V7.66797C13.334 8.03616 13.6325 8.33464 14.0007 8.33464C14.3688 8.33464 14.6673 8.03616 14.6673 7.66797V5.33463C14.6673 3.86187 13.4734 2.66797 12.0007 2.66797H4.00065ZM13.334 5.33463C13.334 4.59826 12.737 4.0013 12.0007 4.0013H4.00065C3.26427 4.0013 2.66732 4.59826 2.66732 5.33464L13.334 5.33463Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 11.3333C8 9.49228 9.49228 8 11.3333 8C13.1744 8 14.6667 9.49228 14.6667 11.3333C14.6667 13.1744 13.1744 14.6667 11.3333 14.6667C9.49228 14.6667 8 13.1744 8 11.3333ZM13.4681 10.7793C13.7144 10.5576 13.7344 10.1783 13.5127 9.93195C13.291 9.68565 12.9117 9.66568 12.6653 9.88736L10.8445 11.5261L10.1348 10.8874C9.88846 10.6657 9.50909 10.6856 9.28742 10.932C9.06574 11.1783 9.08571 11.5576 9.33201 11.7793L10.4431 12.7793C10.6713 12.9847 11.0177 12.9847 11.2459 12.7793L13.4681 10.7793Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPayMent2);
export default __webpack_public_path__ + "static/media/IconPayMent2.58263ba1818c2f1a1bbe856636e5284f.svg";
export { ForwardRef as ReactComponent };